export const USER_URL_SEGMENT = "user";
